import { GraphIcon } from '~/@mid_ui/icons/GraphIcon'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { Text } from '~/@mid_ui/typography/Text'

type Props = {
  isCompany: boolean
}

function RegistrationOverview({ isCompany }: Props) {
  const points = [
    { text: 'Vytvorte si prístupové údaje', icon: <GraphIcon /> },
    { text: 'Zadajte telefónne číslo', icon: <GraphIcon /> },
    {
      text: 'Telefónne číslo overte prostredníctvom kódu, ktorý vám zašleme do SMS.',
      icon: <GraphIcon />,
    },
    ...(isCompany
      ? [{ text: 'Doplňte údaje o vašej firme/živnosti', icon: <GraphIcon /> }]
      : []),
    {
      text: 'Prezrite si všetky dostupné investičné príležitosti',
      icon: <GraphIcon />,
    },
  ]

  return (
    <div className="flex flex-col justify-center items-start max-w-125 gap-8">
      <HeadingThree className="text-2xl text-primary-foreground">
        Registrácia krok za krokom
      </HeadingThree>
      <div className="flex flex-col gap-6">
        {points.map(({ icon, text }, index) => (
          <div
            key={`RegistrationInfoPoint-${index}`}
            className="flex flex-row items-start text-primary-foreground font-semibold">
            <span className="mr-4">{icon}</span>
            <Text className="text-primary-foreground">{text}</Text>
          </div>
        ))}
      </div>
    </div>
  )
}

export { RegistrationOverview }
